module.exports = __webpack_public_path__ + "static/media/hero-thumb-2.919573e1.svg";